// extracted by mini-css-extract-plugin
module.exports = {"container":"filter-comments_container__3SrB6","title":"filter-comments_title__3hNlk"};